import React from 'react';
import { Star } from 'lucide-react';
import { Card } from '../ui/Card';
export function Testimonials() {
  return <section className="py-20 bg-slate-50" data-id="element-165">
      <div className="container mx-auto px-4" data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-168">
            Familias que ahora duermen tranquilas
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-169">
          <Card className="p-6" data-id="element-170">
            <div className="flex gap-1 text-amber-400 mb-4" data-id="element-171">
              <Star className="w-5 h-5 fill-current" data-id="element-172" />
              <Star className="w-5 h-5 fill-current" data-id="element-173" />
              <Star className="w-5 h-5 fill-current" data-id="element-174" />
              <Star className="w-5 h-5 fill-current" data-id="element-175" />
              <Star className="w-5 h-5 fill-current" data-id="element-176" />
            </div>
            <p className="text-slate-700 mb-6 italic" data-id="element-177">
              "Siempre tuve miedo de qué pasaría con mis niñas. Ahora tengo la
              Carpeta Roja lista y mi hermana tiene los poderes firmados. Es
              como quitarse un peso de 100 libras de encima."
            </p>
            <div className="font-bold text-slate-900" data-id="element-178">- María G., Texas</div>
          </Card>

          <Card className="p-6" data-id="element-179">
            <div className="flex gap-1 text-amber-400 mb-4" data-id="element-180">
              <Star className="w-5 h-5 fill-current" data-id="element-181" />
              <Star className="w-5 h-5 fill-current" data-id="element-182" />
              <Star className="w-5 h-5 fill-current" data-id="element-183" />
              <Star className="w-5 h-5 fill-current" data-id="element-184" />
              <Star className="w-5 h-5 fill-current" data-id="element-185" />
            </div>
            <p className="text-slate-700 mb-6 italic" data-id="element-186">
              "No sabía que con mi ITIN podía hacer esto. Pensé que necesitaba
              ser ciudadano. El Protocolo Sombrilla me abrió los ojos y protegió
              mis ahorros."
            </p>
            <div className="font-bold text-slate-900" data-id="element-187">
              - Carlos R., California
            </div>
          </Card>

          <Card className="p-6" data-id="element-188">
            <div className="flex gap-1 text-amber-400 mb-4" data-id="element-189">
              <Star className="w-5 h-5 fill-current" data-id="element-190" />
              <Star className="w-5 h-5 fill-current" data-id="element-191" />
              <Star className="w-5 h-5 fill-current" data-id="element-192" />
              <Star className="w-5 h-5 fill-current" data-id="element-193" />
              <Star className="w-5 h-5 fill-current" data-id="element-194" />
            </div>
            <p className="text-slate-700 mb-6 italic" data-id="element-195">
              "Por $37 esto es un regalo. Un abogado me quería cobrar $1,500 por
              lo mismo. Gracias por hacer esto accesible para nuestra
              comunidad."
            </p>
            <div className="font-bold text-slate-900" data-id="element-196">- Sofía M., Florida</div>
          </Card>
        </div>
      </div>
    </section>;
}